"use client";

import React, { useState, useEffect } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StartTheConversation() {
  const [currentDate, setCurrentDate] = useState<string>("");
  useEffect(() => {
    const dateOptions: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    setCurrentDate(new Date().toLocaleDateString('en-US', dateOptions));
  }, []);
  return <section data-section-id="235875" id="start-the-conversation" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-40 flex flex-col items-center justify-center min-h-[85vh]">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688832/img/charmhaven_coastline_consulting.png" alt="Future Mind Consulting" className="w-full h-full object-cover opacity-40 blur-[2px]" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/40 pointer-events-none z-0" />
      <div className="absolute -bottom-[20%] left-1/2 -translate-x-1/2 w-[120%] md:w-[80%] aspect-square bg-primary/10 blur-3xl rounded-lg pointer-events-none opacity-30 z-0" />

      <div className="container relative z-10 px-4 md:px-6 flex flex-col items-center text-center">
        
        <Badge variant="outline" className="mb-10 md:mb-14 border-primary/30 text-primary px-5 py-2 text-xs md:text-sm uppercase tracking-widest backdrop-blur-xl bg-card/60 font-mono">
          {currentDate || "Strategic Innovation"}
        </Badge>

        <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter max-w-5xl mx-auto leading-[1.05] text-balance uppercase text-white">
          The Future Begins with a <span className="text-primary">Conversation</span>.
        </h1>

        <p className="mt-8 md:mt-12 text-base md:text-lg text-muted-foreground font-medium tracking-widest uppercase font-mono">
          — Future Mind Consulting
        </p>

        <div className="mt-12 md:mt-16">
          <Button asChild size="lg" className="rounded-md px-10 h-14 text-base font-semibold tracking-wide shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all duration-300 bg-primary text-primary-foreground">
            <Link to="/ConnectPage">
              Book a Consultation
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}